<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  modelValue: boolean
  label?: string
}>(), {
  label: () => ''
})

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void
}>()

const value = computed({
    get() {
        return props.modelValue
    },
    set(val) {
        emit("update:modelValue", val)
    }
})

</script>

<template>
    <div class="flex items-center gap-2">
      <label v-if="label" class="text-xs text-neutral-700">{{ label }}</label>
      <button @click="value = !value" class="appearance-none relative flex w-10 h-5 bg-grey !rounded-full transition-all" :class="[value == true ? '!bg-primary-500 dark:!bg-primary-700 !rounded-full outline-primary-500 dark:outline-primary-700' : 'bg-neutral-200 dark:bg-neutral-500 outline-neutral-200 dark:outline-neutral-500']">
          <div class="handle absolute w-5 h-5 rounded-full transition-all left-0 border-2" :class="[value == true ? 'bg-white left-5 border-primary-500' : 'bg-white border-neutral-200']"></div>
      </button>
    </div>
</template>